<ion-row class="tip-component">
	<ion-col class="ion-no-padding">
		<ion-row class="title-row">
			<h5 class="title">
				{{ 'tip_component.title' | translate }}
			</h5>
			<!-- <p class="chip" (click)="showCustomPicker()">
            {{ 'tip_component.custom' | translate }}
          </p> -->
		</ion-row>
		<ion-row class="tip-row">
			@for (percent of percents; track percent) {
				<ion-col (click)="select(percent)" size="4">
					<div [class.selected]="percent === selectedPercent" class="tip">
						@if (percent == 5) {
							<ion-img class="tip-img" src="../../../assets/tips/5.svg"></ion-img>
						}
						@if (percent == 10) {
							<ion-img class="tip-img" src="../../../assets/tips/10.svg"></ion-img>
						}
						@if (percent == 15) {
							<ion-img class="tip-img" src="../../../assets/tips/15.svg"></ion-img>
						}
						<p class="sum">{{ percent }}%</p>
					</div>
				</ion-col>
			}
			<!-- <ion-col *ngIf="customTip" class="tip" [class.selected]="customTip">
            <ion-img class="tip-img" src="../../../assets/tips/20.png"></ion-img>
            <p class="sum">+{{ numberToCurrency(customTip, currency) }}</p>
          </ion-col> -->
		</ion-row>
	</ion-col>
</ion-row>
